import { Check } from "lucide-react";
import { SWATCH } from "../../lib/shop";

export const PieceSelector = ({ idx, spec, value, onChange, item }) => {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div className="rounded-2xl bg-[#FFF4F8] p-5" data-testid={`piece-${idx}`}>
      <p className="font-display text-lg font-bold">{spec.label}</p>
      <p className="mt-3 text-sm font-semibold">Color{value.color && <span className="font-normal text-black/60">: {value.color}</span>}</p>
      <div className="mt-2 flex flex-wrap gap-2" data-testid={`piece-${idx}-colors`}>
        {spec.colors.map((c) => (
          <button type="button" key={c} onClick={() => set("color", c)} title={c} aria-label={c} data-testid={`piece-${idx}-color-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className={`relative grid h-9 w-9 place-items-center rounded-full ring-1 ring-black/15 transition-transform hover:scale-110 ${value.color === c ? "ring-2 ring-[#FF1F8E] ring-offset-2" : ""}`}
            style={{ background: SWATCH[c] || "#E5E5E5" }}>
            {value.color === c && <Check className="h-4 w-4 drop-shadow" style={{ color: ["White", "Ash", "Sand", "Light Pink", "Gold", "Light Blue"].includes(c) ? "#000" : "#fff" }} />}
            {!SWATCH[c] && <span className="text-[9px] font-bold">{c.slice(0, 3)}</span>}
          </button>
        ))}
      </div>
      <p className="mt-4 text-sm font-semibold">Size</p>
      <div className="mt-2 flex flex-wrap gap-2">
        {spec.sizes.map((s) => (
          <button type="button" key={s} onClick={() => set("size", s)} data-testid={`piece-${idx}-size-${s.toLowerCase()}`}
            className={`min-w-12 rounded-xl px-3 py-2 text-sm font-semibold transition-colors ${value.size === s ? "bg-[#0E0B0D] text-white" : "bg-white ring-1 ring-[#EBD08A]"}`}>
            {s}{item.plus_sizes.includes(s) && item.plus_size_fee > 0 && <span className="ml-1 text-[10px] opacity-70">+${item.plus_size_fee}</span>}
          </button>
        ))}
      </div>
      {item.personalization_fee >= 0 && (
        <label className="mt-4 block">
          <span className="text-sm font-semibold">Sleeve personalization <span className="font-normal text-black/55">(optional{item.personalization_fee > 0 ? `, +$${item.personalization_fee}` : ""})</span></span>
          <input value={value.personalization || ""} onChange={(e) => set("personalization", e.target.value)} maxLength={120} placeholder="e.g. name or year"
            className="mt-1 w-full rounded-xl border border-[#EBD08A] bg-white px-4 py-2.5 outline-none focus:border-[#FF1F8E]" data-testid={`piece-${idx}-personalization`} />
        </label>
      )}
    </div>
  );
};
